import React from 'react';

import { Box, MenuItem } from 'components';
import { Buildings } from 'iconsax-react';

import { i18n, useTranslation } from 'third-party';

import { OrganizationType } from 'constants/common';

import { ListFilter } from 'components/Table/Filtering/ListFilter';
import { ColumnFilteringProps, TableColumn } from 'components/Table/types';

import { getOrganizationAvatarUrl } from 'utils/app';

import { APIOrganization } from 'types/api';

export const OrganizationTypeFilter: React.FC<ColumnFilteringProps> = props => {
  const { t } = useTranslation();

  return (
    <ListFilter {...props}>
      <MenuItem key="all" value={undefined}>
        {t('common.all')}
      </MenuItem>
      <MenuItem value={OrganizationType.Live}>
        {t('superAdmin.type.live')}
      </MenuItem>
      <MenuItem value={OrganizationType.Sandbox}>
        {t('superAdmin.type.sandbox')}
      </MenuItem>
      <MenuItem value={OrganizationType.Disabled}>
        {t('superAdmin.type.disabled')}
      </MenuItem>
    </ListFilter>
  );
};

export const organizationColumns = (): TableColumn<APIOrganization>[] => [
  {
    dataId: 'avatar',
    label: 'superAdmin.column.avatar',
    minWidth: 48,
    width: 64,
    sortable: false,
    resizable: false,
    notFilterable: true,
    cannotBeHidden: false,
    formatter: (_value: any, item: APIOrganization) => {
      const avatarUrl = getOrganizationAvatarUrl(item);
      return {
        value: '',
        element: avatarUrl ? (
          <Box
            component="img"
            src={avatarUrl}
            alt={item.name}
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Buildings variant="TwoTone" size="16" color={'#fff'} />
          </Box>
        ),
      };
    },
  },
  {
    dataId: 'name',
    label: 'superAdmin.column.name',
    minWidth: 120,
    width: 220,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'description',
    label: 'superAdmin.column.description',
    minWidth: 120,
    width: 300,
    sortable: false,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'type',
    label: 'superAdmin.column.type',
    minWidth: 80,
    width: 120,
    sortable: false,
    resizable: true,
    customFilter: OrganizationTypeFilter,
    formatter: (_value: any, item: APIOrganization) => {
      const labelsByType = {
        [OrganizationType.Live]: 'superAdmin.type.live',
        [OrganizationType.Sandbox]: 'superAdmin.type.sandbox',
        [OrganizationType.Disabled]: 'superAdmin.type.disabled',
      };

      if (item.isDisabled) {
        return {
          value: i18n.t(labelsByType[OrganizationType.Disabled]).toString(),
        };
      }

      const type = item.isSandbox
        ? OrganizationType.Sandbox
        : OrganizationType.Live;

      return { value: i18n.t(labelsByType[type]).toString() };
    },
  },
];
